ignoreResultsRef